import React, { SVGProps } from 'react';

const SvgNotificationsActive = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg width="26" height="29" viewBox="0 0 26 29" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="13" cy="16" r="13" fill="#1F1E1E" />
			<path d="M16.5 13.6667C16.5 12.7385 16.1313 11.8483 15.4749 11.1919C14.8185 10.5355 13.9283 10.1667 13 10.1667C12.0717 10.1667 11.1815 10.5355 10.5251 11.1919C9.86875 11.8483 9.5 12.7385 9.5 13.6667C9.5 17.7501 7.75 18.9167 7.75 18.9167H18.25C18.25 18.9167 16.5 17.7501 16.5 13.6667Z" fill="white" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
			<path d="M14.0091 21.25C13.9065 21.4268 13.7593 21.5735 13.5822 21.6756C13.4051 21.7776 13.2043 21.8313 12.9999 21.8313C12.7955 21.8313 12.5947 21.7776 12.4176 21.6756C12.2405 21.5735 12.0933 21.4268 11.9907 21.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
			<circle cx="20" cy="5" r="3" fill="#4C80FF" />
			<circle opacity="0.2" cx="20" cy="5" r="5" fill="#C2C0C0" />
		</svg>
	);
}

export default SvgNotificationsActive;